import React from 'react';
const PresenterParticipantsView = () => {
    return (
            // <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                // <div style={{  marginLeft: '20px', display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '1rem', border: '1px solid redirect' }}>
                    <div id="participantElement" className="participant-panel"></div>
                // </div>
            // </div>
    );
};

export default PresenterParticipantsView;
